"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlTransactionStatusSerialization = void 0;
const ChargingSessionAttemptIdWithPortSerialization_1 = require("./ChargingSessionAttemptIdWithPortSerialization");
class ChargerControlTransactionStatusSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.failed_session_attempts = entity.failed_session_attempts?.map((field) => field
            ? JSON.parse(ChargingSessionAttemptIdWithPortSerialization_1.ChargingSessionAttemptIdWithPortSerialization.serialize(field))
            : undefined);
        copy.active_session_attempts = entity.active_session_attempts?.map((field) => field
            ? JSON.parse(ChargingSessionAttemptIdWithPortSerialization_1.ChargingSessionAttemptIdWithPortSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.failed_session_attempts = entity.failed_session_attempts?.map((field) => field
            ? ChargingSessionAttemptIdWithPortSerialization_1.ChargingSessionAttemptIdWithPortSerialization.deserialize(JSON.stringify(field))
            : undefined);
        copy.active_session_attempts = entity.active_session_attempts?.map((field) => field
            ? ChargingSessionAttemptIdWithPortSerialization_1.ChargingSessionAttemptIdWithPortSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ChargerControlTransactionStatusSerialization = ChargerControlTransactionStatusSerialization;
